import { PublicClientApplication, Configuration, LogLevel, PopupRequest } from '@azure/msal-browser';

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_OPENID_CLIENTID, // Твой Client ID
    authority: import.meta.env.VITE_OPENID_CONNECT_DISCOVERY_ENDPOINT, // Policy в Azure B2C
    knownAuthorities: [import.meta.env.VITE_OPENID_KNOWN_AUTHORITIES], // Домен B2C
    redirectUri: `${window.location.origin}/`, // URL для редиректа после логина
    // postLogoutRedirectUri: `${window.location.origin}/logout`, // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: true
    // navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.

  },
  cache: {
    cacheLocation: "localStorage", // Или "localStorage"
    storeAuthStateInCookie: false, // Для поддержки старых браузеров
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        // console.log(message);
      },
      logLevel: LogLevel.Trace,
      piiLoggingEnabled: false
    }
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);


export const loginRequest: PopupRequest = {
  scopes: ["User.Read"],
};
